module.exports = __webpack_public_path__ + "img/bg_7.59a0f93f.png";